import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { connect,  useDispatch, useSelector } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks';
import rehypeRaw from "rehype-raw";
import { 
  contentActions, 
  content_groupActions, 
  commentActions, 
  assigned_userActions, 
  contentLabelActions, 
  work_spaceActions, 
  minimized_content_groupActions, 
  alertActions 
} from '../../../actions';
import {
  Popup,
  LoadSpinner,
  UserThumbnails,
  StageLabel,
  ContentLabel,
  ContentGroupInlineEdit,
  DateTimeInlineEdit,
  ContentInlineEdit,
  StopWatch,
  HiddenContentImageUploader,
  CircleAddIcon,
  ElementTooltip,
  MarkAsCompleteButton,
  CardTag,
  ReminderInlineEdit,
} from '../../../components';
import { adminBaseURL, buildFormDataFromObject } from '../../../utils/commonUtils';
import ChatMessage from "../ContentPage/chat";
import {
  Image as ImageHelper,
  workspaceSizeAlert,
  getDropdownPosition,
  reminderDisplayText,
  checkContentAttachmentsLimit
} from '../../../utils';
import { Button, Dropdown, Row, Col, CloseButton, Image, Spinner } from "react-bootstrap";
import ContentReplace from "../ContentPage/replace";
import {useDetectOutsideClick} from "../../../utils/useDetectOutsideClick";
import AttachmentsCarousel from "../ContentPage/sections/attachments_carousel";
import { useMediaQuery } from 'react-responsive'
import ContentLabelPopup from "../ContentLabelPopup/list";
import AssignedUserNew from "../AssignedUserPage/new";
import StartDateIcon from "../../../images/icons/start-date.svg";
import DueDateIcon from "../../../images/icons/due-date.svg";
import RevisionCountIcon from "../../../images/icons/edit.svg";
import LabelIcon from "../../../images/icons/label.svg";
import ParticipantIcon from "../../../images/icons/participant.svg";
import ReplaceIcon from "../../../images/icons/white/replace.svg";
import DeleteIcon from "../../../images/icons/white/delete.svg";
import TimeSpentIcon from "../../../images/icons/time-spent.svg";
import ReminderIcon from "../../../images/icons/reminder.svg";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import StageIcon from "../../../images/icons/stage.svg";
import { CONTENT_GROUP_ACTION, CONTENT_GROUP_DUPLICATE, CONTENT_GROUP_MESSAGE, tooltipConstants, userConstants } from '../../../constants';
import { dateTimeFormatter, checkImagesSize } from '../../../utils/';
import { mediaQueryConstants } from '../../../constants';
import MobileContentGroupNav from './mobile/mobileContentGroupNav';
import SettingsIcon from '../../../images/icons/dark/settings.svg';
import { createCancelToken } from '../../../utils/Axios';
import { GoToSubtaskButton, SubtaskSection } from '../../../components/subtask';
import { ContentGroupProvider } from '../../../providers/ContentGroupProvider';
import useSelectedAttachmentsHook from '../../../hooks/useSelectedAttachmentsHook';
import { SelectedAttachmentContext } from '../../../contexts/SelectedAttachmentContext';
import { SelectedAttachmentPanel } from '../../../components/content_group_attachment/SelectedAttachmentPanel';
import useTemporaryUrl from '../../../hooks/useTemporaryUrl';
import { LineIcon } from '../../../components/icons/LineIcon';
import { useRehashCard } from '../../../utils/useRehashCard';
import { useMinimizeCardLoadHook } from '../../../hooks/useMinimizeCardLoadHook';
import { HeaderTitle } from '../../../components/HeaderTitle';
import DropdownIcon from '../../../images/icons/dropdown-arrow.svg';
import { DismissablePopup } from '../../../components/popup';
import { useCardVisitCreateHook } from '../../../hooks/useCardVisitCreateHook';
import CardBackToTopButton from '../../../components/card/components/CardBackToTopButton';
import useCardBackToTopButton from '../../../components/card/hooks/useCardBackToTopButton';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import WorkspaceLogoThumbnail from 'components/workspace/WorkspaceLogoThumbnail';

function ContentList(props) {
  const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` })
  const ref = useRef();
  const labelDropdownDetectorRef = useRef();
  const {
    content_group_id,
    updated_at,
    workspace_id,
    content_popup_notification,
    currentWorkSpace,
    content_loading,
    content_group_loading
  } = props;
  const [selected_content_id, setSelectedContentId] = useState(null);
  const [showMobileLabelPopup, setShowMobileLabelPopup] = useState(false);
  const filter_options =[
    "all",
    "active",
    "hidden"
  ];
  const dispatch = useDispatch();
  const {
    contents,
    can_add,
    content_group,
    currentContent,
    handleCloseContentGroupPopUp,
    handleInlineEdit,
    can_access_accept_request_revision,
    can_access_content_versions,
    can_access_content_download,
    can_access_reject_revision,
    can_access_show_team_comment,
    can_access_accept_revision,
    can_access_team_comment,
    can_assign_user,
    can_access_submit_approval,
    can_access_edit_label,
    can_access_add_change_date,
    can_access_content_update,
    can_access_content_create,
    can_access_content_hide,
    can_access_content_destroy,
    can_access_content_comment,
    can_access_content_group_archive,
    can_access_assigned_user,
    can_access_move_content_board,
    can_access_show_content_details,
    can_sort_attachments,
    highlighted_comment,
    draft_comment_loading,
    update_comment_loading,
    draft_attachment_loading,
    draft_render_loading,
    fromRecycleBin,
    attachment_downloading,
    can_access_clone_content_group
  } = props

  const isTimeTracked = content_group?.stage?.enable_timestamp;
  const { createVisit } = useCardVisitCreateHook({});

  useEffect(() => {
    return () => {
      if(content_group_id && workspace_id){
        createVisit(workspace_id, content_group_id);
      }
    }
  }, [])

  let { readOnly = false } = props;

  if(content_group?.deleted_at){
    readOnly = true;
  }

  const { selected_attachments, setSelectedAttachments, toggleSelectedAttachment } = useSelectedAttachmentsHook();
  const selectedAttachmentContextValue = {
    selected_attachments,
    setSelectedAttachments,
    toggleSelectedAttachment
  };
  const authorizations = {
    can_access_accept_request_revision,
    can_access_accept_revision,
    can_access_content_versions,
    can_access_add_change_date,
    can_access_assigned_user,
    can_access_content_comment,
    can_access_content_create,
    can_access_content_destroy,
    can_access_content_download,
    can_access_content_group_archive,
    can_access_content_hide,
    can_access_content_update,
    can_access_content_versions,
    can_access_edit_label,
    can_access_move_content_board,
    can_access_reject_revision,
    can_access_show_content_details,
    can_access_show_team_comment,
    can_access_submit_approval,
    can_access_team_comment,
    can_add,
    can_assign_user,
    can_sort_attachments
  }
  const { assigned_users } = content_group || {};

  const workspaceBaseUrl = adminBaseURL("workspaces");
  const Interval_MS = 60000; // 1 minute
  const [contentIndex, setContentIndex] = useState(0);
  const [initialLoad, setInitialLoad] = useState(true);
  const galleryRef = useRef();
  let latestURL = '';
  const [selectedAttachmentId, setSelectedAttachmentId] = useState(0);
  let { mode } = useParams();
  let modalRef = useRef();
  const [chatFocused, setChatFocused] = useState(false);
  const [editorFocused, setEditorFocused] = useState(false);
  const content_loading_ref = useRef(content_loading);
  const reminder_ref = useRef();
  const cardTitleRef = useRef();
  const [seeTaskNode, setSeeTaskNode] = useState(null);
  const seeTaskParentRef = useCallback((el) => {
    if (el) {
      setSeeTaskNode(el); // triggers render → effect
    }
  }, []);
  const [drpdwnPosition, setDrpdwnPosition] = useState({
    top: 0,
    left: 0
  })
  const [tabLoaded, setTabLoaded] = useState(false);
  const IntervalCancelTokenRef = useRef(createCancelToken())
  const rehash = useRehashCard();
  const { isModalOpen: isClonePopupOpen } = useSelector(state => state.card_duplicate);
  const isFetchAlive = useRef(true);
  const loading = draft_comment_loading || update_comment_loading || draft_attachment_loading || draft_render_loading;
  const { isMinimized } = useMinimizeCardLoadHook({ content_group_id, dispatch });

  const newUrl = useMemo(() => {
    if (!currentWorkSpace || !workspace_id || !content_group) return undefined;

    if(fromRecycleBin){
      return `/organizations/${currentWorkSpace?.organization_id}/workspaces/${workspace_id}/content/${content_group.id}-${content_group.parameterize_name}/recycle_bin`; 
    }

    const base = `/organizations/${currentWorkSpace.organization_id}${workspaceBaseUrl}/${workspace_id}/content/${content_group.id}-${content_group.parameterize_name}`;

    const commentMatch = highlighted_comment?.id && 
      highlighted_comment.cg_id?.toString() === content_group.id?.toString();

    const fullPath = commentMatch
      ? `${base}/comments/${highlighted_comment.id}/${highlighted_comment.internal}-${highlighted_comment.cg_id}`
      : base;

    return fullPath;
  }, [content_group, content_group_id, highlighted_comment, workspace_id, currentWorkSpace, fromRecycleBin]);

  const customOriginalPath = useMemo(() => {
    if (!currentWorkSpace || !workspace_id) return undefined;

    const base = fromRecycleBin ? 
      `/organizations/${currentWorkSpace.organization_id}/recycle_bin`
    :
      `/organizations/${currentWorkSpace.organization_id}${workspaceBaseUrl}/${workspace_id}/list`;

    return base;
  }, [workspace_id, currentWorkSpace, fromRecycleBin]);

  // Hooks
  useTemporaryUrl(newUrl, customOriginalPath);
  const {
    position:positionBackToTop,
    show: showBackToTop,
    handleBackToTop
  } = useCardBackToTopButton({
    parentRef: seeTaskNode
  });

  const setActiveTab = (activeTab) => {
    dispatch({ type: userConstants.SET_COMMENT_ACTIVE_TAB, payload: activeTab })
  }

  useEffect(() => {
    if(isMinimized && initialLoad){
      dispatch({ type: userConstants.CONTENT_LOADING })
    }
  }, [initialLoad, isMinimized])

  useEffect(() => {
    const cancel_token_source = createCancelToken();

    showContent({setInitialLoad, cancel_token_source});
    
    return function cleanup() {
      cancel_token_source.cancel('Operation canceled by the user');
    };
  }, [loading]);

  useEffect(() => {
    if(!content_group_id) return;

    const handleKeyDown = (event) => {
      if (!ref.current) {
         return;
      }

      if (isClonePopupOpen) {
        if (event.key === "Escape") {
          dispatch({ type: CONTENT_GROUP_DUPLICATE.CLOSE_DUPLICATE_MODAL });
          return;
        }
      }

      if (event.key === "Escape") {
        if (labelDropdownDetectorRef.current){
          handleCloseLabelsPopup()
        } else {
          handleCloseButtonClick()
        }
      }
    }

    document.addEventListener("popstate", handleCloseContentGroupPopUp);
    document.addEventListener("keydown", handleKeyDown);
    ref.current?.focus();

    return function cleanup() {
      document.removeEventListener("popstate", handleCloseContentGroupPopUp);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [content_group, isClonePopupOpen]);

  useEffect(() => {
    content_loading_ref.current = content_loading
 }, [content_loading]);

  useEffect(() => {
    isFetchAlive.current = true;
    let timeoutId;

    const fetchContent = async () => {
      if(readOnly === false){
        showContent({cancel_token_source: IntervalCancelTokenRef.current});
      }

      if(isFetchAlive.current){
        timeoutId = setTimeout(fetchContent, Interval_MS);
      } 
   }

   fetchContent();

   return () => {
    isFetchAlive.current = false;
    clearInterval(timeoutId);
    dispatch({ type: CONTENT_GROUP_ACTION.UNSET_HIGHLIGHTED_COMMENT });
    if(IntervalCancelTokenRef.current){
      IntervalCancelTokenRef.current.cancel('Operation canceled by the user');
    } 
  }
 }, []);

  useEffect(() => {
    if(readOnly){
      IntervalCancelTokenRef.current.cancel('Operation canceled by the user');
    }
    return () => {

    }
  }, [readOnly]);

  // Load Content Group and Attachment
  const showContent = (
    {
      setInitialLoad,
      cancel_token_source = createCancelToken()
    }
  ) => {
    const onBefore = () => {
      if(setInitialLoad && isMinimized){
        //dispatch({ type: userConstants.CONTENT_LOADING });
      }
    }
    if (content_group_id && !content_loading_ref.current) {
      const load = true;
      const getContentParams = {
        workspace_id,
        content_group_id,
        load,
        cancel_token_source
      };

      dispatch(contentActions.getContent(getContentParams));

      const showContentParams = {
        workspace_id,
        content_group_id,
        closeModal: handleCloseContentPopup,
        setInitialLoad,
        cancel_token_source,
        onBefore
      };

      dispatch(contentActions.showContent(showContentParams));
    }
  }

  /*Content Add*/
  const [content_add_form, setContentAddForm] = useState({id: null, show:false});

  const handleCloseContentAddForm = () => {
    setContentAddForm({id: null, show: false});
  }

  const handleOpenContentAddForm = (id) => {
    setContentAddForm({id: id, show: true})
  }

  /*Content Replace*/
  const [content_replace_form, setContentReplaceForm] = useState({id: null, show:false});

  const handleCloseContentReplaceForm = (reload) => {
    if(reload){
      const getContentParams = {
        workspace_id,
        content_group_id
      };

      dispatch(contentActions.getContent(getContentParams));

      const showContentParams = {
        workspace_id,
        content_group_id,
      };

      dispatch(contentActions.showContent(showContentParams));
    }

    setContentReplaceForm({id: null, show: false});
  }

  const handleOpenContentReplaceForm = (id) => {
    handleCloseContentAddForm();
    dispatch(contentActions.editContent(workspace_id, content_group_id, id, setContentReplaceForm));
  }

  /* Popup Modal*/

  const hideContent = (id) => {
    dispatch(contentActions.hideContent(workspace_id, content_group_id,id));
  }

  const unhideContent = (id) => {
    dispatch(contentActions.unhideContent(workspace_id, content_group_id,id));
  }

  const deleteContent = (id) => {
    dispatch(contentActions.destroyContent(workspace_id, content_group_id,id, currentContent && currentContent.id == id, content_popup_notification));
  }

  /* Preview Panel */
  const [hidePreviewPanel, setHidePreviewPanel] = useState({
    hide: false
  });

  const toggleHidePreviewPanel = () => {
    setHidePreviewPanel({ hide: !hidePreviewPanel.hide })
  }

  /* Popup Modal*/
  const [popup, setPopUp] = useState({
    show: false, id: null,
  });

  const handleClose = () => {
    setPopUp({show: false, id: null});
    setSelectedAttachmentId(0);
  };

  const handleShow = (id) => setPopUp({show: true, id: id});

  const handleDelete = () => {
    deleteContent(popup.id);
    handleClose();
  }
  /*
    Popup Delete Modal
  */
  const [popupDeleteForm, setPopUpDeleteForm] = useState(false);

  const handleCloseDeleteForm = () => {
    setPopUpDeleteForm(false);
  }

  const handleShowDeleteForm = () => setPopUpDeleteForm(true);

  const handleDeleteContentGroup = () => {
    const onSuccess = (response) => {
        const dont_load_workspace = true;
        dispatch(work_spaceActions.showWorkSpace(workspace_id, dont_load_workspace));
        dispatch({ type: CONTENT_GROUP_ACTION.REMOVE_MINIMIZED_CARD, payload: response.data.data.id })
        dispatch({
                    type: userConstants.DESTROYED_CONTENTGROUP,
                    payload: response
                  })

        handleCloseContentPopup();

        dispatch(alertActions.success(userConstants.DELETE_CONTENTGROUP));
    }

    const onError = (response) => {
      dispatch(alertActions.error(response.data.error));
    }

    const params = {
      workspace_id,
      content_group_id,
      onSuccess,
      onError
    }
    dispatch(content_groupActions.deleteContentGroup(params));
  }

  /*
    Popup Archive Modal
  */
  const [popupArchiveForm, setPopUpArchiveForm] = useState(false);

  const handleCloseArchiveForm = () => {
    setPopUpArchiveForm(false);
  }

  const handleShowArchiveForm = () => setPopUpArchiveForm(true);

  const handleArchiveContentGroup = () => {
    dispatch(content_groupActions.archiveContentGroup(workspace_id, content_group_id, (content_group && content_group.archived), handleCloseArchiveForm));
  }

  // For comment in Request Revision
  const [description, setDescription]= useState("");

  /*
    Status Change Modal
  */
  const statuses = [
    'request_revision',
    'submit_for_approval',
    'void_submit',
    'approve_content_group',
    'accept_request',
    'reject_request'
  ]

  const [isDisabled, setIsDisabled] = useState(false);
  const [popupStatusChangeForm, setStatusChangeForm] = useState({show: false, id: null, status: ''});

  let filtered_contents = contents

  let hasContents = filtered_contents && filtered_contents.length > 0;

  filtered_contents && filtered_contents.sort((a,b) => a.position - b.position);

  /* Content List */

  const handleContentSelection = (id) => {
    if(selected_content_id){
      setSelectedContentId(null)
    }
    else{
      setSelectedContentId(id)
    }
  }

  const [tab, setTab] = useState(can_access_content_update || can_access_show_content_details ? 'info' : 'contents');

  useEffect(() => {
    if(tabLoaded) return;

    if(highlighted_comment?.id){
      setTab('comments');
      setTabLoaded(true);
      return;
    }

    if (can_access_content_update || can_access_show_content_details){
      setTab('info');
      setTabLoaded(true);
    }

 }, [can_access_content_update, can_access_show_content_details]);

  const handleContentInlineEdit = (values, content_id) => {
    let formData = new FormData();
    buildFormDataFromObject(formData, values, "content");
    formData.append("replace", true)
    dispatch(contentActions.updateContentInlineEdit(formData, content_id,workspace_id, content_group_id, content_popup_notification));
  }

  const dropdownRef = useRef(null);
  const [showParticipantPopup, setShowParticipantPopup] = useDetectOutsideClick(dropdownRef, false)
  const [showMobileParticipantPopup, setShowMobileParticipantPopup] = useState(false)
  const [activePopupHead, setActivePopupHead] = useState(false)

  const activeDropDownPopup = (content_group_id, status) => {
    if(status == 'active_popup') {
      setActivePopupHead(!activePopupHead)
    }else{
      setShowParticipantPopup(prevState => !prevState);
      setShowMobileParticipantPopup(prevState => !prevState);
    }
  }

  const closePopupInContent = () => {
    setActivePopupHead(false);
  }

  const handleOpenAssignedUserEditPopup = useCallback((id, fromList, status) => {
    if (workspace_id && id){
        dispatch(assigned_userActions.newAssignedUser(workspace_id, id, activeDropDownPopup, status)); 
    }
  }, [workspace_id]);

  {/* Label Dropdown */}
  const labelsDropdownRef = useRef(null);
  const [showLabelDropdown, setShowLabelDropdown] = useDetectOutsideClick(labelsDropdownRef, false)
  labelDropdownDetectorRef.current = showLabelDropdown;

  const handleOpenLabelsPopup = (e) => {
    let styles = getDropdownPosition({target: e.target, dropdown: labelsDropdownRef.current, left_padding: 0, top_padding: 0})

    dispatch(contentLabelActions.getContentLabels(workspace_id))
    setShowMobileLabelPopup(true)
    setDrpdwnPosition(styles)
    setShowLabelDropdown(true)
  }

  const handleCloseLabelsPopup = () => {
    if(loading) return;

    setTimeout(() => {
      setShowLabelDropdown(false)
      setShowMobileLabelPopup(false)
    }, 100)
  }
  {/* End Label Dropdown */}

  const [ contentAttachmentValue, setContentAttachmentValue] = useState(currentContent && currentContent.content_attachment);

  const [selectContentId, setSelectContentId] = useState(currentContent && currentContent.id)
  useEffect(() => {
    let filter_data = filtered_contents && filtered_contents.filter((item, index) => index === contentIndex ).map(({id}) => (id));
    if (!!filter_data) {
      setSelectContentId(filter_data[0])
    }
  }, [currentContent])

  useEffect(() => {
    closePopups();
  }, [isLargeScreen])

  const _onSlide = (e) => {
    let filter_data = filtered_contents && filtered_contents.filter((item, index) => index === e ).map(({id}) => (id));
    if (!!filter_data) {
      setSelectContentId(filter_data[0]);

      if (filter_data[0] !== selectedAttachmentId){
        setSelectedAttachmentId(0);
      }
    }
    setContentIndex(e);
  }

  const addFile = e => {
    let formData = new FormData();
    buildFormDataFromObject(formData, { attachment: e.target.files}, "content");

    dispatch(contentActions.createContent(formData, workspace_id, content_group_id, content_popup_notification ));
  }

  const handleFileChange = e => {
    if(selectedAttachmentId === 0 ) return;

    let limitExceeded = checkImagesSize([e.target.files[0]], currentWorkSpace?.personal);

    if(!limitExceeded && e.target.files.length > 0){
      workspaceSizeAlert(currentWorkSpace);
      setContentAttachmentValue(URL.createObjectURL(e.target.files[0]));
      handleContentInlineEdit({ attachment: e.target.files[0] }, selectedAttachmentId)
    }

    e.target.value = '';
  }

  const hiddenFileInput = useRef(null);
  const handleFileUploadClick = event => hiddenFileInput.current.click();

  let contents_in_slider = filtered_contents && filtered_contents.map(item => {

    return {
      id: item.id,
      fullscreen: item.content_attachment,
      original: item.original && can_access_submit_approval ? item.original.url : item.content_attachment,
      thumbnail: item.small ? item.small.url : item.content_attachment
    }
  })

  const handleCloneClick = (e) => {
      const boundary = e.target.getBoundingClientRect();
      const is_escapable = false;

      dispatch({ type: CONTENT_GROUP_DUPLICATE.OPEN_DUPLICATE_MODAL, payload: { content_group_id: content_group.id, workspace_id, boundary, stage_id: content_group?.stage?.id, escapeable: is_escapable } });
  }

  const renderContentGroupSettings = () => {
    if (!(content_group && content_group.can_crud_content_group && (can_access_content_group_archive || can_access_clone_content_group))) return;
    if (readOnly) return;

    return (
      <div className="content-group_settings">
        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic" className="d-flex align-items-center justify-content-center" title="Options" style={{padding: '0px'}}>
            <Image src={SettingsIcon} height={18}/>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{right: "auto"}} key={'up'}>
            {
              can_access_clone_content_group &&
               <Button variant="secondary" className="dropdown-item" onClick={handleCloneClick}>Copy</Button>
            }

            {(content_group.can_crud_content_group) &&
              <>
                <Dropdown.Divider />
                <Button 
                  variant="secondary" 
                  className="dropdown-item" 
                  onClick={() => isTimeTracked ? null : handleShowDeleteForm(true)} 
                  disabled={isTimeTracked}>
                    Move to Recycle Bin
                </Button>
              </>
            }
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
  }

  const addFileInput = useRef(null);

  const handleContentClick = (e) => {
    let currentItem = galleryRef.current.props.items[galleryRef.current.getCurrentIndex()]

    if (currentItem){
      window.open(currentItem.original, '_blank');
    }
  }

  const stageParentRef = useRef(null);

  const handleCloseContentPopup = () =>{
    if(loading) return;
    
    let previous_url = sessionStorage.getItem("previous_url");
    if(previous_url){
      window.history.replaceState(null,null, previous_url)
    }

    dispatch(contentActions.removeCurrentContentGroup());
    handleCloseContentGroupPopUp();
  }

  const handleCloseButtonClick = () => {
    if(loading) return;


    const onBefore = () => {
        dispatch({
            type: CONTENT_GROUP_ACTION.REMOVE_MINIMIZED_CARD,
            payload: content_group.id
        });
    }

    const params = {
        content_group_id: content_group.id,
        onBefore
    }

    dispatch(minimized_content_groupActions.removeMinimizedContentGroup(params));

    handleCloseContentPopup();
  }

  const closePopups = () => {
    setShowParticipantPopup(false);
    setShowMobileParticipantPopup(false);
  }

  const hiddenAddFileInput = useRef(null);

  const handleDeleteLabel = (label_id, e) => {
    e.stopPropagation();

    let requestParams = { label_id: label_id, assigned: false }
    let callback = () => {}

    dispatch(content_groupActions.assignContentLabelToContentGroup(workspace_id, content_group_id, requestParams, content_popup_notification, callback))
  }

  const cardTitle = (className) => {
    return(
      <div className={`d-flex ${className}`} ref={cardTitleRef}>
        {
          currentWorkSpace &&
          <>
            <WorkspaceLogoThumbnail workspace={currentWorkSpace}/>
            <div
              className={ can_access_content_update ? 'd-flex align-items-center' : ''}
              style={currentWorkSpace?.logo ? {width: `calc(100% - ${isLargeScreen ? '80px' : '56px'})` } : {width: `${ isLargeScreen ? 'calc(100% - 56px)' : '100%'}`}}
            >
              <ContentGroupInlineEdit
                content_group_data={content_group?.name}
                edit_type="content_group_title"
                can_access_content_update={can_access_content_update && readOnly === false}
                workspace_logo={currentWorkSpace?.logo}
                handleInlineEdit={(handleOnBlur, name) => handleInlineEdit(handleOnBlur, name, content_group.id,)}
              />
            
              {
                !can_access_show_content_details &&

                <div className="d-flex">
                  <small
                    style={{fontSize: '0.8em'}}
                  >
                    in
                    <b> { content_group?.stage_name } </b>
                    stage
                    due on
                    <span> {( content_group?.due_date ?
                            <>
                              <b>
                                {dateTimeFormatter(content_group.due_date, 'date_only')} 
                              </b>
                              {" at "}
                              <b>
                                 {dateTimeFormatter(content_group.due_date, 'time_only')}
                              </b>
                            </>
                            
                          :
                            '-'
                        ) }
                    </span>
                  </small>
                </div>
              }
            </div>

            <CardTag
              completed={content_group?.completed}
              due_date={content_group?.due_date}
              reminder_in_day={content_group?.reminder_in_day}
            />

            {
              isLargeScreen &&
              <>
                <div 
                  className='miniminize-icon d-flex align-items-center justify-content-center cursor-pointer me-2 ms-4'
                  onClick={handleMinimizeContentPopup}
                >
                  <LineIcon pathFill={'#0F172A'}/>
                </div>
                <CloseButton
                  variant='white'
                  onClick={() => handleCloseButtonClick()}
                  style={{position: 'initial'}}
                  title="Close" />
              </>
            }
            

          </>
        }
      </div>
    )
  }

  const { isLimitReached: isAttachmentLimitReached } = checkContentAttachmentsLimit({ attachments: contents })
  const disabledAddAttachment = isAttachmentLimitReached || readOnly || content_loading || attachment_downloading;

  const handleMinimizeContentPopup = () => {
    const rehashed_content_group = rehash({content_group, workspace: currentWorkSpace, authorizations, assigned_users});
    
    const onBefore = () => {
      dispatch({type: CONTENT_GROUP_ACTION.MINIMIZE_CARD, payload: rehashed_content_group});
      handleCloseContentPopup();
    }

    const onError = (error) => {
      console.error("Error minimizing content group:", error);
      // Handle error if needed
    }

    const params = {
      content_group_id: content_group.id,
      onBefore,
      onError
    }

    dispatch(minimized_content_groupActions.createMinimizedContentGroup(params));
   
  }

  return (
    <ContentGroupProvider
      content_group_id={content_group?.id}
      workspace_id={workspace_id}
      handleContentInlineEdit={handleContentInlineEdit}
      disabledAddAttachment={disabledAddAttachment }
      handleInlineEdit={handleInlineEdit}
      readOnly={readOnly}
    >
      {/* SEO */}
      {
        content_group?.name &&
        <HeaderTitle title={content_group.name} />
      }
      
      <div
        ref={ref}
        className={`px-0 container-fluid container-page_container ${content_popup_notification} ${isLargeScreen ? 'mobile_container_page' : "window"}`}
        style={{zIndex: 1024}}
      >
        <div className={activePopupHead ? 'overlay' : ''} onClick={activePopupHead ? () => closePopupInContent() : null} style={{zIndex: 1024}}> </div>
        {
          !isMinimized &&
          (
            (initialLoad || props.assigned_user_loading) && <LoadSpinner spinner={true} />
          )
        }
        {
          !isLargeScreen && (
            <>
              <div 
                className='miniminize-icon position-absolute d-flex align-items-center justify-content-center cursor-pointer me-2'
                onClick={handleMinimizeContentPopup}
              >
                  <LineIcon />
              </div>
              <CloseButton variant='white' onClick={() => handleCloseButtonClick()} title="Close" />
            </>
          ) 
        }
        {
          content_group && (isMinimized || !initialLoad) &&
          <div
            className={`container-page_modal-holder ${isLargeScreen ? 'mobile_content_popup' : 'window_content_popup'}`}
            ref={modalRef}
          >
            <div className="h-100 container-fluid p-0">
              <Row
                style={{ height: "100%", alignItems: "flex-start" }}
                className={`${isLargeScreen ? '' : 'p-2'} m-auto`}
              >
                <Col
                  lg={12}
                  className="p-0 h-100"
                  style={{
                    position: 'relative'
                  }}
                >
                  <div id="content_popup_wrapper" className="flex_container h-100">
                    <div className="current_content_group-container h-100">
                      <div
                        className={`current_content_group-container-grid ${isLargeScreen ? '' : 'flex-lg-row flex-column'}`}
                        >
                        {
                          isLargeScreen &&
                          cardTitle('mx-4 mt-2 align-items-center justify-content-between content-group-title')
                        }

                        <div
                          className={`content__details-sidebar ${isLargeScreen ? 'm-4 mt-0' : 'mx-2'}`}
                          style={{
                            display: isLargeScreen ? tab === "info" ? 'block' : 'none' : 'block',
                          }}
                        >
                          <div
                            className={can_access_show_content_details ? `h-100 ${ isLargeScreen ? 'p-0 m-0' : ' ' } content__details-sidebar_list vertical-scroll_thin hidden-scroll` : 'd-none'}
                            style={{flex: 0, minWidth: 220}}
                          >
                            <div className="content__details-detail mb-3">
                              <label className="mb-2">
                                <div className="d-flex align-items-center">
                                  <img src={StageIcon} height="14" className="attribute-icon stage-icon" />
                                  Stage
                                </div>
                              </label>

                              <StageLabel
                                name={ content_group && content_group.stage_name }
                                selected_stage_id={ content_group?.stage_id }
                                can_access_edit_title={ can_access_move_content_board && readOnly === false }
                                stages={ content_group.allowed_stages }
                                stageParentRef={stageParentRef}
                                scrollable={true}
                                alignment={'left'}
                                asDropdown={true}
                                containerClassName={'btn-outline-gray d-flex flex-column'}
                                hoverable={can_access_move_content_board && readOnly === false}
                                handleInlineEdit={(handleOnBlur, stage_id) => handleInlineEdit(handleOnBlur, stage_id, content_group.id,)}
                              />
                            </div>


                            <div className="content__details-detail mb-3">
                              <label className="mb-2">
                                <div className="d-flex align-items-center">
                                  <img src={StartDateIcon} height="14" className="attribute-icon" />
                                  Start Date
                                </div>
                              </label>

                              {can_access_add_change_date && readOnly === false ?

                                  <DateTimeInlineEdit
                                    content_group_date={content_group && content_group.start_date}
                                    type="start_date"
                                    handleInlineEdit={(handleOnBlur, start_date, setIsDisabled) => handleInlineEdit(handleOnBlur, start_date, content_group?.id, setIsDisabled)}
                                    buttonType={'text'}
                                    asDropdown={true}
                                    hoverable={true}
                                    activeBordered={true}
                                  />
                                  :
                                    <div className={`detail bg-transparent`}>
                                      {
                                        ( content_group.start_date ?
                                            dateTimeFormatter(content_group.start_date)
                                          :
                                            '-'
                                        )
                                      }
                                    </div>

                                }

                              </div>

                              <div className="content__details-detail mb-3">
                                <label className="mb-2">
                                  <div className="d-flex align-items-center">
                                    <img src={DueDateIcon} height="14" className="attribute-icon due_date-icon" />
                                    Due Date

                                    <ElementTooltip
                                      tooltip_title={'Due Date'}
                                      tooltip_text={tooltipConstants.LABEL_DUE_DATE}
                                      id={'content_popup-label-due_date'}
                                      className={'ml-2'}
                                    />
                                  </div>
                                </label>

                                {can_access_add_change_date && readOnly === false ?
                                    <DateTimeInlineEdit
                                      content_group_date={content_group && content_group.due_date}
                                      type="due_date"
                                      handleInlineEdit={(handleOnBlur, due_date, setIsDisabled) => handleInlineEdit(handleOnBlur, due_date, content_group?.id, setIsDisabled)}
                                      buttonType={'text'}
                                      asDropdown={true}
                                      activeBordered={true}
                                      hoverable={true}
                                      containerClassName={'d-flex flex-column'}
                                    />

                                  :
                                    <div className={`detail bg-transparent`}>
                                      {
                                        ( content_group.due_date ?
                                            dateTimeFormatter(content_group.due_date)
                                          :
                                          '-'
                                        )
                                      }
                                    </div>

                              }

                            </div>


                            <div className="content__details-detail mb-3">
                              <label className="mb-2">
                                <div className="d-flex align-items-center">
                                  <img src={ReminderIcon} height="14" className="attribute-icon" />
                                  Reminder
                                </div>
                              </label>

                              {
                                can_access_content_update && readOnly === false ?
                                  <ReminderInlineEdit
                                    content_group={content_group}
                                    scrollable={true}
                                    parentRef={reminder_ref}
                                    handleInlineEdit={(reminder_in_day) => handleInlineEdit(() => null, reminder_in_day, content_group.id)}
                                    hoverable={true}
                                  />
                                :

                                  <div className={`detail btn-outline-gray btn-sm`}>
                                    { reminderDisplayText(content_group?.reminder_in_day) }
                                  </div>
                              }

                            </div>

                            <div className="content__details-detail mb-3">
                              <div>
                                <label
                                  className={`mb-2 ${isLargeScreen && 'mt-0'}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <img src={ParticipantIcon} className="attribute-icon participant-icon" />
                                    Participants

                                    <ElementTooltip
                                      tooltip_title={'Participants'}
                                      tooltip_text={tooltipConstants.LABEL_PARTICIPANTS}
                                      id={'content-popup_label_participants'}
                                      className={'ml-2'}
                                      placement={'auto'}
                                    />
                                  </div>
                                </label>

                                { (assigned_users && assigned_users.length > 0) ?
                                  <div className={`detail bg-transparent ${(!can_access_assigned_user || readOnly) && 'no_access' }`}>
                                    <UserThumbnails
                                      users={assigned_users}
                                      className="d-block"
                                      limit={8}
                                      openPopup={can_access_assigned_user && readOnly === false ? () => handleOpenAssignedUserEditPopup(content_group.id, false, 'active_body') : null }
                                      openUserSummary={true}
                                      workspace_id={workspace_id}
                                      organization_id={currentWorkSpace?.organization_id}
                                      avatarBorderColor={'#fafafa'}
                                    />
                                  </div>
                                  :
                                  <div
                                    className={`detail hoverable flex-column d-flex btn-dashed ${ isLargeScreen ? showMobileParticipantPopup && 'active' : showParticipantPopup  && 'active' } ${can_access_assigned_user && readOnly === false ? '' : 'bg-transparent'}`} 
                                    onClick={ can_access_assigned_user && readOnly === false ? () => handleOpenAssignedUserEditPopup(content_group.id, false) : null} style={{cursor: 'pointer'}}
                                  >
                                    {can_access_assigned_user && readOnly === false ?
                                        <div 
                                          className="inline_button inline_button d-flex align-items-center"
                                          style={{ flex: 1}}
                                        >
                                            Add Participant...
                                        </div>
                                      :
                                        "-"
                                    }

                                    {
                                      assigned_users?.length === 0 &&
                                        <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/>
                                    }  
                                  </div>
                                }

                                <AssignedUserNew
                                  dropdownRef={dropdownRef}
                                  isActive={showParticipantPopup}
                                  showMobilePopup={showMobileParticipantPopup}
                                  workspace_id={workspace_id}
                                  content_group_id={content_group.id}
                                  closeDropDownPopup={closePopups}
                                  fromList={false}
                                  content_popup_notification={content_popup_notification}
                                />
                              </div>
                            </div>
                            <div className="content__details-detail position-relative mb-3">
                              <label className={`mb-2`}>
                                <div className="d-flex align-items-center">
                                  <img src={LabelIcon} height="14" className="attribute-icon label-icon" />
                                  Labels
                                </div>
                              </label>
                              { can_access_content_update && readOnly === false ?
                                  <>
                                    <div className={`detail ${content_group?.labels.length === 0 ? 'd-flex flex-column' : ''} hoverable ${ isLargeScreen ? showMobileLabelPopup && 'active' : showLabelDropdown  && 'active' } ${content_group?.labels.length > 0 ? 'btn-transparent' : 'btn-dashed'}`}>
                                      { content_group?.labels.length > 0 ?
                                          content_group.labels.map((contentLabel, index) => (
                                            <ContentLabel
                                              id={contentLabel.id}
                                              name={contentLabel.name}
                                              color_hex={contentLabel.color_hex}
                                              editable={can_access_edit_label}
                                              key={index}
                                              onClick={handleOpenLabelsPopup}
                                              handleDelete={handleDeleteLabel}
                                              custom_close_button_bg_color={"#ededed"}
                                            />
                                          ))
                                        :
                                          <div 
                                            onClick={handleOpenLabelsPopup}
                                            className="d-flex align-items-center cursor-pointer"
                                            style={{ flex: 1, padding: '3px 16px' }}
                                          >
                                            Add Label
                                          </div>
                                      }

                                      {
                                        content_group?.labels.length === 0 &&
                                          <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/>
                                      }
                                      
                                    </div>
                                  </>
                                :
                                  <div className={`detail ${!can_access_edit_label || content_group?.labels.length > 0 || readOnly ? 'bg-transparent' : null}`}>
                                    { content_group?.labels.length > 0 ?
                                        content_group.labels.map((contentLabel, index) => (
                                          <ContentLabel editable={false} name={contentLabel.name} color_hex={contentLabel.color_hex} key={index} />
                                        ))
                                      :
                                        "-"
                                    }

                                  </div>
                              }
                            </div>

                            <div className="content__details-detail mb-3">
                              <label className="mb-2">
                                <div className="d-flex align-items-center">
                                  <img src={RevisionCountIcon} height="14" className="attribute-icon revision_count-icon" />
                                  Revision Count
                                  <ElementTooltip
                                    tooltip_title={'Revision Count'}
                                    tooltip_text={tooltipConstants.LABEL_REVISION_COUNT}
                                    id={'content_popup-label-revision_count'}
                                    className={'ml-2'}
                                  />
                                </div>
                              </label>

                              <div className="detail bg-transparent d-flex align-items-center">
                                {
                                  content_group.revision_count
                                }
                              </div>
                            </div>
                            <div className="content__details-detail mb-3">
                              <label className="mb-2">
                                <div className="d-flex align-items-center">
                                  <img src={TimeSpentIcon} height="14" className="attribute-icon" />
                                  Total Time Spent
                                  <ElementTooltip
                                    tooltip_title={'Total Time Spent'}
                                    tooltip_text={tooltipConstants.LABEL_TIME_TRACK}
                                    id={'content_popup-label-time_spent'}
                                    className={'ml-2'}
                                  />
                                </div>
                              </label>
                              <div className="detail bg-transparent d-flex align-items-center">
                                <StopWatch
                                  initialTime={content_group.timestamp_info?.total_seconds}
                                  initialStartDate={content_group.timestamp_info?.latest_start}
                                  isActive={content_group.stage?.enable_timestamp && content_group.timestamp_info?.active}
                                  viewMode={'POPUP'}
                                />
                              </div>
                            </div>

                            {
                              can_access_content_update && readOnly === false &&
                                <div className="content__details-detail mb-3">
                                  <MarkAsCompleteButton
                                    content_group={content_group}
                                    handleInlineEdit={(completed) => handleInlineEdit(() => null, completed, content_group?.id)}
                                  />
                                </div>
                            }


                            { renderContentGroupSettings()  }
                          </div>
                        </div>
                        <div
                          className={`contents-container position-relative ${ isLargeScreen ? '' : 'mx-2' } mt-2 vertical-scroll_thin hidden-scroll`}
                          id={'contentContainer'}
                          style={{
                            display: isLargeScreen ? tab === "contents" ? 'block' : 'none' : 'block',
                          }}
                          ref={seeTaskParentRef}
                        >

                          <GoToSubtaskButton parentRef={seeTaskNode} />
                          <CardBackToTopButton isVisible={showBackToTop} onClick={handleBackToTop} position={positionBackToTop} />
                          <div id="current-container">
                            <div>
                              <div className="mb-4">
                                {
                                  !isLargeScreen &&
                                  cardTitle('mb-4 content-group-title align-items-center')
                                }

                                {
                                  !can_access_show_content_details &&

                                  <div className={`mt-2 ${ isLargeScreen && 'mx-4' } mb-2`}>
                                    {
                                      content_group?.labels?.map((contentLabel, index) => (
                                        <ContentLabel
                                          name={contentLabel.name}
                                          color_hex={contentLabel.color_hex}
                                          editable={false}
                                          key={index}
                                        />
                                      ))
                                    }
                                  </div>
                                }

                                { content_replace_form.show &&
                                  <ContentReplace
                                    handleClose={handleCloseContentReplaceForm}
                                    content_id={content_replace_form.id}
                                    content_group_id={content_group && content_group.id}
                                    hasContents={hasContents}
                                    workspace_id={workspace_id}
                                    content_popup_notification={content_popup_notification}
                                  />
                                }
                                <div style={{position: "relative" }} className='mb-2'>
                                  {contents && contents.length > 0 &&
                                    !hidePreviewPanel.hide &&
                                      <div>
                                        <SelectedAttachmentContext.Provider value={selectedAttachmentContextValue}>
                                          <div className='position-relative'>
                                                                                    {
                                            (content_loading || attachment_downloading) &&
                                              <div 
                                                className="position-absolute w-100 h-100 rounded"
                                                style={{ 
                                                  background: 'rgba(0, 0, 0, 0.4)', 
                                                  zIndex: 999
                                                }}
                                              >
                                                <div className="spinner-container">
                                                  <Spinner animation="border" variant="light"/>
                                                </div>
                                              </div>
                                            }
                                            <ImageGallery
                                              items={contents_in_slider}
                                              showPlayButton={false}
                                              showFullscreenButton={false}
                                              onSlide={_onSlide}
                                              startIndex={contentIndex}
                                              showThumbnails={false}
                                              lazyLoad={false}
                                              ref={galleryRef}
                                              showNav={false}
                                              onClick={handleContentClick}
                                              disableKeyDown={chatFocused || editorFocused}
                                            />

                                            <SelectedAttachmentPanel 
                                              attachments={filtered_contents}
                                            />
                                          </div>
 
                                          <div style={{ position: 'relative' }}>
                                            <AttachmentsCarousel
                                              attachments={ filtered_contents }
                                              workspace_id={ workspace_id }
                                              content_group_id={ content_group_id }
                                              updated_at={ updated_at }
                                              isDragDisabled={ !can_sort_attachments || readOnly }
                                              selected_id={selectContentId}
                                              galleryRef={galleryRef}
                                              selectedAttachmentId={selectedAttachmentId}
                                              setSelectedAttachmentId={setSelectedAttachmentId}
                                              can_access_content_create={ can_access_content_create && readOnly === false }
                                              content_popup_notification={content_popup_notification}
                                              readOnly={readOnly}
                                            />
                                          </div>
                                        </SelectedAttachmentContext.Provider>
                                      </div>
                                  }
                                  { hasContents &&
                                    <div>
                                      <div
                                        className="chatbtn-group content-group__toolbar-buttons mt-10"
                                      >

                                        <input type="file" onChange={handleFileChange} ref={hiddenFileInput} hidden/>

                                        { selectedAttachmentId !== 0 && can_access_content_update &&
                                          <Button onClick={handleFileUploadClick} className="d-flex btn btn-default mb-1 btn-replace d-flex align-items-center" data-toggle="tooltip" title="Replace File" variant="">
                                            <img src={ReplaceIcon} style={{height: "14px"}} className={'w-100'} />
                                          </Button>
                                        }

                                        {selectedAttachmentId !== 0 && can_access_content_destroy &&
                                          <Button onClick={() => handleShow(selectedAttachmentId)} className="px-1 btn btn-default d-flex align-items-center btn-delete contant-a custom-tooltip" data-toggle="tooltip" title="Delete File" variant={""}>
                                            <img src={DeleteIcon} height="14" className={'w-100'} />
                                          </Button>
                                        }

                                        {currentContent && can_access_content_hide &&(
                                          currentContent && currentContent.is_active ?
                                            <Button onClick={() => hideContent(currentContent && currentContent.id)} className="btn btn-default d-none" variant="">
                                              <img src={ImageHelper.Hide.default} alt="no-image" className="mr-1"/> Hide
                                            </Button>
                                          :
                                            <Button onClick={() => unhideContent(currentContent && currentContent.id)} className="btn btn-default d-none" variant="">
                                            <img src={ImageHelper.Unhide.default} alt="no-image" className="mr-1"/> Unhide
                                            </Button>
                                        )}

                                        {can_access_content_comment &&
                                          <Button className={selected_content_id ? "btn btn-default mr-2 active d-none" : "btn btn-default d-none"} variant="" onClick={() => handleContentSelection(currentContent.id)}>
                                            + Comment
                                          </Button>
                                        }
                                      </div>
                                    </div>
                                  }

                                  <div className="description-section">
                                    {
                                      content_loading && !hasContents &&
                                      <div className="clearfix">
                                        <div className="spinner-container">
                                          <Spinner animation="border" />
                                        </div>
                                      </div>
                                    }
                                    {can_access_content_update && readOnly === false ?
                                      <>
                                        {
                                          !hasContents &&
                                          <>
                                            { content_loading ?
                                                <></>
                                              :
                                                <div className="empty-content_container">
                                                  <HiddenContentImageUploader
                                                    fileInputRef={ hiddenAddFileInput }
                                                    workspace_id={ workspace_id }
                                                    workspace={ currentWorkSpace }
                                                    content_group_id={ content_group_id }
                                                    content_popup_notification={ content_popup_notification }
                                                  />
                                                  <div
                                                    className={`btn btn-dashed btn-sm mb-2 form-control p-2 ${ disabledAddAttachment ? 'disabled' : '' }`}
                                                    onClick={(e) => disabledAddAttachment ? e.stopPropagation() : hiddenAddFileInput.current.click()}
                                                  >
                                                    Add Image
                                                  </div>
                                                </div>
                                            }
                                          </>
                                        }
                                        <ContentInlineEdit
                                          inline_type="content_description"
                                          can_edit={can_add}
                                          handleContentInlineEdit={(description) => handleInlineEdit(() => null, description, content_group.id)}
                                          content_data={content_group.description}
                                          hasContents={hasContents}
                                          workspace_id={workspace_id}
                                          content_group_id={content_group_id}
                                          content_popup_notification={content_popup_notification}
                                          setEditorFocused={setEditorFocused}
                                        />
                                      </>
                                      :
                                      <div className={selected_content_id ? "ck-content content-description active-description" : "ck-content content-description"}>
                                        <ReactMarkdown
                                          children={content_group.description}
                                          remarkPlugins={[remarkGfm, remarkBreaks]}
                                          components={{
                                            a: props => {
                                              return (
                                                <a href={props.href} className="link_color" target="_blank">{props.children}</a>
                                              )
                                            }
                                          }}
                                          rehypePlugins={[rehypeRaw]}
                                        />
                                      </div>
                                    }
                                  </div>

                                  <SubtaskSection readOnly={readOnly} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {
                          true &&
                          <div
                            className="h-100"
                            style={{
                              display: isLargeScreen ? tab === "comments" ? 'block' : 'none' : 'block',
                            }}
                          >
                            <div
                              id="chat_message-container"
                              style={{ flex: "1 0" }}
                              className={`${ isLargeScreen ? 'px-4' : 'px-3 h-100' }`}
                            >
                              <ChatMessage
                                content_group_id={content_group_id}
                                workspace_id={workspace_id}
                                selected_content_id = {selected_content_id}
                                setSelectedContentId = {setSelectedContentId}
                                setActiveTab = { setActiveTab }
                                highlighted_comment={highlighted_comment}
                                setChatFocused={ setChatFocused }
                                cardTitleRef={cardTitleRef}
                                readOnly={readOnly}
                              />
                            </div>
                          </div>
                        }

                        <MobileContentGroupNav
                          setActiveTab={setActiveTab}
                          tab={tab}
                          setTab={setTab}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        }

        {/* Contents */}
        {popup.show &&
          <Popup
            handleClose={handleClose}
            handleDelete={handleDelete}
          />
        }

        {/* Card Delete */}
        <DismissablePopup
          title={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_TITLE }
          confirmText={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_CONFIRM_TEXT }
          message={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_MESSAGE }
          onClose={handleCloseDeleteForm}
          onConfirm={handleDeleteContentGroup}
          show={popupDeleteForm}
        />

        {popupArchiveForm &&
          <Popup
            handleClose={handleCloseArchiveForm}
            handleDelete={handleArchiveContentGroup}
            display_text={content_group && content_group.archived ? "Are you sure you want to unarchive?" : "Are you sure you want to archive?"}
          />
        }

        <nav
          className={`content-label-popup box-shadow vertical-scroll_thin ${showLabelDropdown ? 'active' : ''} `}
          ref={labelsDropdownRef}
          style={drpdwnPosition}
        >
          <ContentLabelPopup
            showMobile={showMobileLabelPopup}
            show={showLabelDropdown}
            labels={ content_group?.labels }
            workspaceId={ workspace_id }
            contentGroupId={ content_group?.id }
            handleClose={ handleCloseLabelsPopup }
            content_popup_notification={ content_popup_notification }
          />
        </nav>
      </div>
    </ContentGroupProvider>

  );
}

const mapStateToProps = (state) => {
  return {
    content_loading: state.content.content_loading,
    contents: state.content.contents,
    can_add: state.content.can_add,
    content_group: state.content.currentContentGroup,
    content_group_loading: state.content_group.content_group_loading,
    currentContent: state.content.currentContent,
    can_assign_user: state.content.can_assign_user,
    can_access_submit_approval: state.content.can_access_submit_approval,
    can_access_content_download: state.content.can_access_content_download,
    can_access_content_versions: state.content.can_access_content_versions,
    can_access_reject_revision: state.content.can_access_reject_revision,
    can_access_show_team_comment: state.content.can_access_show_team_comment,
    can_access_team_comment: state.content.can_access_team_comment,
    can_assign_user: state.content.can_assign_user,
    can_access_accept_revision: state.content.can_access_accept_revision,
    can_access_reject_revision: state.content.can_access_reject_revision,
    can_access_accept_request_revision: state.content.can_access_accept_request_revision,
    can_access_add_change_date: state.content.can_access_add_change_date,
    can_access_content_update: state.content.can_access_content_update,
    can_access_content_create: state.content.can_access_content_create,
    can_access_team_comment: state.content.can_access_team_comment,
    can_access_content_versions: state.content.can_access_content_versions,
    can_access_content_hide: state.content.can_access_content_hide,
    can_access_content_destroy: state.content.can_access_content_destroy,
    can_access_content_comment: state.content.can_access_content_comment,
    can_access_content_group_archive: state.content.can_access_content_group_archive,
    can_access_assigned_user: state.content.can_access_assigned_user,
    can_access_move_content_board: state.content.can_access_move_content_board,
    can_access_show_content_details: state.content.can_access_show_content_details,
    can_sort_attachments: state.content.can_sort_attachments,
    can_access_edit_label: state.content.can_access_edit_label,
    assigned_user_loading: state.assigned_user.assigned_user_loading,
    currentWorkSpace: state.content.currentWorkSpace,
    draft_comment_loading: state.comment.draft_comment_loading,
    update_comment_loading: state.comment.update_comment_loading,
    draft_attachment_loading: state.comment.draft_attachment_loading,
    draft_render_loading: state.comment.draft_render_loading,
    attachment_downloading: state.content.attachment_downloading,
    can_access_clone_content_group: state.content.can_access_clone_content_group
  };
};

export default connect(mapStateToProps, { contentActions })(ContentList);
